// src/lib/pharmacyFirst/pathways/aht/_shared/foundayo-route-helpers.ts
//
// Date maths and named defaults for the Foundayo switch, transfer and re-initiation routes.
// Source: AHT Foundayo PGD v2.1 (Dosage & Frequency; Re-initiation criteria).

/** PGD: gap of 30 days or less resumes the last tolerated dose; more than 30 days restarts at 0.8 mg. */
export const FDY_RESUME_MAX_GAP_DAYS = 30;

/** PGD: re-initiation only within 12 months of the last dose; beyond that, treat as a new initiation. */
export const FDY_REINIT_MAX_DAYS = 365;

/**
 * Minimum days between the last dose of the previous incretin and the first 0.8 mg tablet.
 * SIGN-OFF REQUIRED: OI-F11 — the PGD states 7 days for oral semaglutide only; the change list applies it to every incretin.
 */
export const FDY_SWITCH_MIN_DAYS_SINCE_LAST_DOSE = 7;

/**
 * Longest gap since the last capsule for a capsule-to-tablet transfer.
 * SIGN-OFF REQUIRED: OI-F12 — the PGD says no treatment-free interval is needed but sets no upper limit.
 */
export const FDY_TRANSFER_MAX_DAYS_SINCE_LAST_CAPSULE = 30;

/** Whole days from an ISO date (YYYY-MM-DD) to now. Returns NaN for a missing, malformed or future date. */
export function daysSinceIsoDate(value: unknown, now: Date = new Date()): number {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}/.test(value)) return Number.NaN;
  const then = Date.parse(value.slice(0, 10) + "T00:00:00Z");
  if (!Number.isFinite(then)) return Number.NaN;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.round((today - then) / 86_400_000);
  return days < 0 ? Number.NaN : days;
}
